import { render, staticRenderFns } from "./ForumThreadPost.vue?vue&type=template&id=2a04efd6&"
import script from "./ForumThreadPost.vue?vue&type=script&lang=js&"
export * from "./ForumThreadPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports